(() => {
  const configElement = document.getElementById('nestora-product-config');
  const main = document.getElementById('MainContent');
  if (!configElement || !main) return;
  const config = JSON.parse(configElement.textContent);
  const luminance = (rgb) => rgb.map(v => v / 255).map(v => v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4).reduce((sum, v, i) => sum + v * [.2126, .7152, .0722][i], 0);
  const applyColour = (rgb) => {
    const light = luminance(rgb);
    const ink = (light + .05) / (luminance([17, 17, 17]) + .05) >= 1.05 / (light + .05) ? '#111111' : '#ffffff';
    main.style.setProperty('--nestora-accent', `rgb(${rgb.join(',')})`);
    main.style.setProperty('--nestora-ink', ink);
    main.style.setProperty('--nestora-soft', `rgb(${rgb.map(v => Math.round(v * .12 + 255 * .88)).join(',')})`);
    main.style.setProperty('--nestora-hover', `rgb(${rgb.map(v => Math.round(v * .88)).join(',')})`);
  };
  let colourRequest = 0;
  const colourFromPhoto = (source) => {
    if (!source) return;
    const request = ++colourRequest;
    const photo = new Image();
    photo.crossOrigin = 'anonymous';
    photo.onload = () => {
      if (request !== colourRequest) return;
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 48;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(photo, 0, 0, 48, 48);
        const pixels = context.getImageData(0, 0, 48, 48).data;
        const bins = new Map();
        for (let y = 5; y < 43; y++) for (let x = 5; x < 43; x++) {
          const offset = (y * 48 + x) * 4;
          const rgb = Array.from(pixels.slice(offset, offset + 3));
          const max = Math.max(...rgb), min = Math.min(...rgb);
          if (pixels[offset + 3] < 200 || min > 225 || max < 22) continue;
          const saturation = (max - min) / Math.max(max, 1);
          const key = rgb.map(v => Math.floor(v / 32)).join(',');
          const bin = bins.get(key) || { weight: 0, count: 0, sum: [0, 0, 0] };
          const centerWeight = 1 + (1 - Math.hypot(x - 24, y - 24) / 34);
          bin.weight += centerWeight * (saturation > .18 ? 1 + saturation * 5 : .25);
          bin.count++;
          rgb.forEach((v, i) => bin.sum[i] += v);
          bins.set(key, bin);
        }
        const best = [...bins.values()].sort((a, b) => b.weight - a.weight)[0];
        if (best) applyColour(best.sum.map(v => Math.round(v / best.count)));
      } catch (_) { /* Keep the server-rendered colour if image sampling is unavailable. */ }
    };
    photo.src = source;
  };
  colourFromPhoto(config.image);
  document.addEventListener('variantChanged', (event) => {
    const variant = config.variants.find(v => String(v.id) === String(event.detail?.variantId));
    if (variant) {
      colourFromPhoto(variant.image || config.image);
      main.querySelectorAll('.nestora-buy-now, .nestora-add-to-cart').forEach(button => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? (button.dataset.defaultLabel || config.buyLabel) : config.soldOutLabel;
      });
    }
  });
  let selectedVariantId = new URLSearchParams(window.location.search).get('variant');
  document.addEventListener('variantChanged', (event) => {
    if (config.variants.some(v => String(v.id) === String(event.detail?.variantId))) {
      selectedVariantId = String(event.detail.variantId);
    }
  });
  main.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.tae-buy-now-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.nestoraPending === 'true') return;
    const data = new FormData(form);
    const variant = config.variants.find(v => String(v.id) === selectedVariantId)
      || config.variants.find(v => String(v.id) === String(data.get('id')))
      || config.variants.find(v => v.available);
    if (!variant || !variant.available || !form.reportValidity()) return;
    data.set('id', String(variant.id));
    data.set('quantity', String(Math.max(1, Number(data.get('quantity')) || 1)));
    const buttons = [...form.querySelectorAll('.nestora-buy-now, .nestora-add-to-cart')];
    const addToCart = event.submitter?.classList.contains('nestora-add-to-cart');
    let error = form.querySelector('.nestora-purchase-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'nestora-purchase-error';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.textContent = '';
    form.dataset.nestoraPending = 'true';
    buttons.forEach(button => { button.disabled = true; });
    try {
      const action = new URL(form.action, window.location.origin);
      const response = await fetch(action.pathname + '.js', {
        method: 'POST', body: data, headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      window.location.assign(action.pathname.replace(/cart\/add$/, addToCart ? 'cart' : 'checkout'));
    } catch (failure) {
      error.textContent = failure.message || 'Unable to open checkout. Please try again.';
      form.dataset.nestoraPending = 'false';
      buttons.forEach(button => { button.disabled = false; });
    }
  }, true);
  main.querySelectorAll('.tae-buy-now-form').forEach(form => {
    const payment = form.querySelector('.shopify-payment-button');
    if (!payment || form.querySelector('.nestora-buy-now')) return;
    const button = document.createElement('button');
    button.type = 'submit';
    button.className = 'nestora-buy-now';
    button.textContent = config.available ? config.buyLabel : config.soldOutLabel;
    button.disabled = !config.available;
    payment.hidden = true;
    payment.after(button);
  });
  // Make the entire bundle card selectable, including its text and price.
  main.addEventListener('click', (event) => {
    const card = event.target.closest('.bundle-option');
    if (!card || event.target.closest('input,select,button,a')) return;
    event.preventDefault();
    const radio = card.querySelector('.bundle-quantity-radio');
    if (radio && !radio.checked) radio.click();
  }, true);
})();

